<template>
  <Modal :open.sync="open" size="small" v-loading="loading">
    <div class="dwp-text-green-500 dwp-p-14" v-if="success">Saved succesfully!</div>
    <div class="dwp-space-y-5" v-else>
      <div class="dwp-space-y-2">
        <div
          class="dwp-text-xl dwp-font-medium dwp-flex dwp-items-center dwp-space-x-2"
        >Save As A Template</div>
        <p
          class="dwp-text-gray-600 dwp-text-sm"
        >Save this list to as a template to your cloud library. This lets you can import this list into different projects.</p>
      </div>
      <div class="dwp-space-y-4">
        <TextInput
          @keydown.native.enter="submit"
          ref="listTitle"
          label="Name"
          placeholder="Enter a list name"
          :value="form.title | decode"
          @input="value=>form.title=value"
        />
        <label
          for="text-input-186"
          class="dwp-block dwp-text-sm dwp-font-medium dwp-leading-5 dwp-text-gray-700"
        >
          Description
          <span class="dwp-text-gray-500 dwp-text-sm dwp-font-normal">(optional)</span>
        </label>
        <Editor
          ref="content"
          style="min-height: 75px"
          class="dwp-block dwp-appearance-none dwp-bg-white dwp-rounded dwp-border dwp-border-gray-200 dwp-p-3 focus:dwp-outline-none focus:dwp-shadow-outline focus:dwp-border-gray-500 dwp-w-full sm:dwp-text-sm sm:dwp-leading-5 dwp-shadow-none focus:dwp-shadow-none dwp-border-gray-300 dwp-text-gray-900 dwp-placeholder-gray-500 focus:dwp-border-gray-300 focus:sdwp-hadow-outline-gray dwp-leading-normal"
          placeholder="Add a description to help you identify this list in the future."
          :content.sync="form.description"
        />
        <VButton @click.native="submit">Save To Cloud Library</VButton>
        <VButton type="plain" @click.prevent.native="open = false">Cancel</VButton>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from "@/components/ui/Modal.vue";
import TextInput from "@/components/ui/TextInput.vue";
import VButton from "@/components/ui/VButton.vue";
import Flash from "@/components/ui/Flash.vue";
import Editor from "@/components/shared/Editor.vue";
import { sync } from "vuex-pathify";
import { db } from "@/services/db";
import sortBy from "lodash/sortBy";

export default {
  components: {
    Modal,
    TextInput,
    Flash,
    Editor,
    VButton,
  },
  data() {
    return {
      form: {
        title: "",
        description: "",
      },
      loading: false,
      success: false,
    };
  },
  computed: {
    open: sync("ui/modal@list.save.open"),
    list: sync("ui/modal@list.save.list"),
    tasks: sync("tasks/items"),
    theseTasks() {
      return this.filterObject(this.tasks, (task) => {
        return task.list_id === this.list.id && task.status == "published";
      });
    },
  },
  mounted() {
    this.form.title = this?.list?.title;
  },
  watch: {
    open(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.listTitle.focus();
        });
      }
    },
    "list.title"(val) {
      this.form.title = val;
    },
  },
  methods: {
    async submit() {
      this.loading = true;

      // be sure to get resolved items first!
      await this.$store.dispatch(
        `tasks/fetchAndAdd`,
        {
          where: [
            ["list_id", "==", this.list.id],
            ["status", "==", "published"],
          ],
        },
        { root: true }
      );

      if (!Object.keys(this.theseTasks || {}).length) {
        alert("Please add some tasks first to this list");
      }

      // order tasks
      let order = this?.list?.order || [];
      let byDate = sortBy(Object.values(this.theseTasks || {}), ["created_at"]);
      let ordered = sortBy(byDate, [
        function (o) {
          if (order.indexOf(o.id) == -1) {
            return 99999999999;
          }
          return order.indexOf(o.id);
        },
      ]);

      // push to doc
      let tasks = [];
      (ordered || []).forEach((task) => {
        tasks.push({
          title: task.title,
          notes: task.notes,
        });
      });

      let id = await this.$store.dispatch("team-lists-library/add", {
        title: this.form.title,
        description: this.form.description,
        count: this.list.counts.total || 0,
        tasks,
      });

      this.success = true;
      this.loading = false;

      setTimeout(() => {
        this.open = false;
      }, 2000);

      this.form.title = "";
    },
  },
};
</script>